module.exports = __webpack_public_path__ + "front/img/0_kv.c3e2e3d1.png";